import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@apollo/client';
import Modal from '../../../../../../components/Modal';
import TextInput from '../../../../../../components/TextInput';
import { Sheet } from '../AllergenModal/styled';
import { Field } from '../ProductEditModal/styled';
import Button from '../../../../../../components/Button';
import { HeaderSmall } from '../../../../../../components/Text';
import { formatPrice } from '@/utils/formatter';
import {
  ClickableTr,
  NoSearchResultContainer,
  SearchResultTable,
} from './styled';
import Checkbox from '../../../../../../components/Checkbox';
import { addExtrasToGroup as addExtrasToGroupMutation } from '../../../../../../graphql/mutations';
import { productCategories as productCategoriesQuery } from '../../../../../../graphql/queries';
import i18n from '@/utils/i18n';

function AddExtraModal({
  onClose,
  allExtrasForBrand,
  productId,
  groupId,
  storeId,
}) {
  const [extraSearchTerm, setExtraSearchTerm] = useState('');
  const [productSearchTerm, setProductSearchTerm] = useState('');
  const [searchResults, updateSearchResults] = useState([]);
  const [selectedExtras, setSelectedExtras] = useState([]);
  const [addExtrasToGroup, { loading }] = useMutation(addExtrasToGroupMutation);

  function onExtraSearchTermChange(e) {
    const searchTermInput = e.target.value;
    setExtraSearchTerm(searchTermInput);
    doSearch(searchTermInput, productSearchTerm);
  }

  function onProductSearchTermChange(e) {
    const searchTermInput = e.target.value;
    setProductSearchTerm(searchTermInput);
    doSearch(extraSearchTerm, searchTermInput);
  }

  function doSearch(extraSearchTermInput, productSearchTermInput) {
    const extraSearchTermInputLowercase = extraSearchTermInput.toLowerCase();
    const productSearchTermInputLowercase =
      productSearchTermInput.toLowerCase();
    const filteredSearchResults = allExtrasForBrand.filter(
      (extra) =>
        (extra.extra_id.toLowerCase().includes(extraSearchTermInputLowercase) ||
          (extra.name &&
            extra.name
              .toLowerCase()
              .includes(extraSearchTermInputLowercase))) &&
        (productSearchTermInputLowercase.trim() === '' ||
          extra.product.id
            .toLowerCase()
            .includes(productSearchTermInputLowercase) ||
          (extra.product.name &&
            extra.product.name
              .toLowerCase()
              .includes(productSearchTermInputLowercase))),
    );
    const filteredSearchResultsWithoutDoubles = [];
    filteredSearchResults.forEach((filteredExtra) => {
      if (
        !filteredSearchResultsWithoutDoubles.find(
          (e) => e.extra_id === filteredExtra.extra_id,
        )
      ) {
        filteredSearchResultsWithoutDoubles.push(filteredExtra);
      }
    });
    updateSearchResults(filteredSearchResultsWithoutDoubles);
  }

  function toggleExtraSelection(sr) {
    const id = sr.extra_id;
    if (selectedExtras.find((extra) => extra.extra_id === id)) {
      setSelectedExtras(
        selectedExtras.filter((extra) => extra.extra_id !== id),
      );
    } else {
      setSelectedExtras([...selectedExtras, sr]);
    }
  }

  function updateExtrasOfProduct() {
    const extraIdsToAdd = selectedExtras.map((extra) => extra.extra_id);
    addExtrasToGroup({
      variables: {
        product_id: productId,
        group_id: groupId,
        extra_ids: extraIdsToAdd,
      },
      refetchQueries: [
        {
          query: productCategoriesQuery,
          variables: {
            id: storeId,
            filter: 'ALL',
          },
        },
      ],
      onError: (err) => {
        // eslint-disable-next-line no-console
        console.log(err);
        // eslint-disable-next-line no-alert
        alert(err);
      },
    });
  }

  const selectedExtraCount = selectedExtras.length;

  return (
    <Modal onClose={onClose}>
      <Sheet>
        <Button
          disabled={selectedExtraCount === 0}
          onClick={updateExtrasOfProduct}
          loading={loading}
        >
          {`Add (${selectedExtraCount}) extras`}
        </Button>
        <br />
        <HeaderSmall>Search for Extra</HeaderSmall>
        <Field>
          <TextInput
            name="extra-search"
            placeholder={i18n.t('Common:extraKeywordPlaceholder')}
            onChange={onExtraSearchTermChange}
            value={extraSearchTerm}
          />
        </Field>
        <HeaderSmall>Search for Product</HeaderSmall>
        <Field>
          <TextInput
            name="product-search"
            placeholder={i18n.t('Common:productKeywordPlaceholder')}
            onChange={onProductSearchTermChange}
            value={productSearchTerm}
          />
        </Field>
        <SearchResultTable>
          <thead>
            <tr>
              <th>#</th>
              <th>extra name</th>
              <th>price</th>
            </tr>
          </thead>
          <tbody>
            {searchResults.map((sr, i) => (
              // eslint-disable-next-line react/no-array-index-key
              <ClickableTr key={i} onClick={() => toggleExtraSelection(sr)}>
                <td width={25}>
                  <Checkbox
                    checked={selectedExtras.find(
                      (extra) => extra.extra_id === sr.extra_id,
                    )}
                  />
                </td>
                <td title={sr.extra_id}>{sr.name}</td>
                <td>{formatPrice(sr.price)}</td>
              </ClickableTr>
            ))}
          </tbody>
        </SearchResultTable>
        {searchResults.length === 0 && (
          <NoSearchResultContainer>No extras found</NoSearchResultContainer>
        )}
      </Sheet>
    </Modal>
  );
}

AddExtraModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  productId: PropTypes.string.isRequired,
  storeId: PropTypes.string.isRequired,
  groupId: PropTypes.string.isRequired,
  allExtrasForBrand: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default AddExtraModal;
